import React from 'react'

// This component was created for Foremost Farms, it's a limited date picker for the appointment pickup date

const PUApptDateLimited = ({ render, apptPUDate, shipmentObjUpdateEvent, availableDate1, inputFieldsReadOnly }) => {
    if (!render) {
        return null
    }
    let readOnly = false
    if (!availableDate1 || inputFieldsReadOnly) {
        readOnly = true
    }
    let minDateStr = ''
    let maxDateStr = ''

    if (!readOnly) {
        const minDate = new Date(availableDate1)
        minDate.setDate(minDate.getDate() - 3)
        const maxDate = new Date(availableDate1)
        maxDate.setDate(maxDate.getDate() + 3)
        // console.log('minDate', minDate, 'maxDate', maxDate)
        minDateStr = minDate.toISOString().split('T')[0]
        maxDateStr = maxDate.toISOString().split('T')[0]
    }

    if (render && apptPUDate && shipmentObjUpdateEvent) {
        return (
            <div className="form-group col col-lg-2">
                <label>Appt. Pickup:</label>
                <input
                    className="form-control form-control-sm"
                    name="dates.appointmentPickupDate"
                    onChange={(event) => shipmentObjUpdateEvent(event)}
                    type="date"
                    value={apptPUDate}
                    min={minDateStr}
                    max={maxDateStr}
                    readOnly={readOnly}
                />
            </div>
        )
    } else {
        return null
    }
}

export default PUApptDateLimited
